import React from 'react';
import { List, ListItem, makeStyles, Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import cx from 'classnames';
import { CustomTheme } from 'common/ui/interfaces';

import messages from '../../messages';

const useStyles = makeStyles((theme: CustomTheme) => ({
  caption: {
    paddingTop: '24px',
    paddingBottom: '16px',
  },
  link: {
    color: theme.palette.error.main,
    textDecoration: 'underline',
    fontSize: '1rem',
    lineHeight: '32px',
  },
  dateText: {
    fontSize: '1rem',
    paddingBottom: '16px',
  },
  descriptionText: {
    fontSize: '1rem',
  },
  list: {
    listStyleType: 'disc',
    padding: '0 0 0 16px',
  },
  listItem: {
    display: 'list-item',
    '&::marker': {
      content: '"• "',
    },
  },
  text: {
    fontSize: '1rem',
    lineHeight: '32px',
  },
  boldText: {
    fontWeight: 500,
  },
}));

const CookiePolicy = () => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.whatAreCookies)}
      </Typography>
      <Typography className={classes.text}>{intl.formatMessage(messages.anHTTPcookie)}</Typography>
      <Typography className={cx(classes.text, classes.boldText)}>
        {intl.formatMessage(messages.byUsingThisWebsit)}
        &nbsp;
        <Link className={classes.link} to="https://www.peakpayment.com" target="_blank">
          peakpayment.com
        </Link>
        &nbsp;
        {intl.formatMessage(messages.youAgreeToOurCookiePolicy)}
      </Typography>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.howWeUseCookies)}
      </Typography>
      <Typography className={classes.text}>{intl.formatMessage(messages.weUseCookies)}</Typography>
      <Typography className={classes.text}>
        {intl.formatMessage(messages.soWhatDoWeStore)}
      </Typography>
      <List className={classes.list}>
        <ListItem className={classes.listItem}>
          <Typography className={cx(classes.text, classes.boldText)}>
            {intl.formatMessage(messages.imagesFontsAndIconGlyphs)}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={cx(classes.text, classes.boldText)}>
            {intl.formatMessage(messages.anonymousAnalyticsData)}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={cx(classes.text, classes.boldText)}>
            {intl.formatMessage(messages.geoAnalyticsData)}
          </Typography>
        </ListItem>
      </List>
      <Typography className={classes.text}>{intl.formatMessage(messages.andThatsIt)}</Typography>
      <Typography className={classes.text}>
        {intl.formatMessage(messages.weUnderstandYourRightToPrivacy)}
      </Typography>
    </>
  );
};

export default CookiePolicy;
